import React from 'react';
import { Inbox } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { C } from '../data/constants.js';

interface EmptyStateProps {
  icon?: LucideIcon;
  title?: string;
  message?: string;
}

export function EmptyState({
  icon: Icon = Inbox,
  title = 'No Data Available',
  message = 'This data is not yet being collected for this facility.',
}: EmptyStateProps): React.ReactElement {
  return (
    <div
      style={{
        background: C.card,
        border: `1px solid ${C.cardBorder}`,
        borderRadius: 16,
        padding: '48px 24px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        animation: 'insights-fadeSlideUp 0.5s ease',
      }}
    >
      <div
        style={{
          width: 48,
          height: 48,
          borderRadius: 14,
          background: 'rgba(255,255,255,0.04)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Icon size={22} color={C.textFaint} />
      </div>
      <div style={{ fontSize: 14, fontWeight: 600, color: C.textDim }}>{title}</div>
      <div style={{ fontSize: 12, color: C.textFaint, textAlign: 'center', maxWidth: 320 }}>
        {message}
      </div>
    </div>
  );
}
